import { render, staticRenderFns } from "./WBtnAdd.vue?vue&type=template&id=3842776a&scoped=true&"
import script from "./WBtnAdd.vue?vue&type=script&lang=js&"
export * from "./WBtnAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842776a",
  null
  
)

export default component.exports